enum IconColourClass {
  Dark = 'icn--dark',
  Muted = 'icn--muted',
  Action = 'icn--info',
  Light = 'icn--light',
  Success = 'icn--success',
  Warning = 'icn--warning',
  Error = 'icn--error',
}

export default IconColourClass
